var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"select-item",style:({
    background: _vm.computedBackgroundColor,
    color: _vm.computedContentColor,
  }),on:{"mouseenter":_vm.handleHoverEnter,"mouseleave":_vm.handleHoverLeave,"mousedown":_vm.handleClick}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text || _vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }